import { useEffect, useMemo, useState } from "react";
import { Form, Modal, Button, Table } from "react-bootstrap";
import styles from "./style.module.css";

export default function WorkshopOrder({ onHide, currentReceipt, isForDesigner }) {
    const [file, setFile] = useState("");
    const [order, setOrder] = useState();

    useEffect(() => {
        if (currentReceipt !== "") setOrder(JSON.parse(currentReceipt));
        if (!file) return;
        setOrder(JSON.parse(file));
    }, [file, currentReceipt]);

    const content = useMemo(() => {
        if (!order) return "";

        return (
            <div>
                <Table striped bordered hover size="sm">
                    <thead style={{ backgroundColor: "#e3f2fd" }}>
                        <tr>
                            <th>#</th>
                            <th>Категория</th>
                            <th>Подтип</th>
                            <th>Материал</th>
                            <th>Нанесение</th>
                            <th>Размер</th>
                            <th>Дополнения</th>
                            {!isForDesigner ? <th>Количество</th> : ''}
                        </tr>
                    </thead>
                    <tbody>
                        {order.products.map((p, index) => (
                            <tr key={p.key || p.id}>
                                <td>{index + 1}</td>
                                <td>
                                    {p.categoryName === "Диз. прочее" ? "—" : p.categoryName}
                                </td>
                                <td>{p.subtypeId == 3 ? p.name : p.subtypeName}</td>
                                {/*^^^Если подтип - название медали, то вместо подтипа вставляем само название продукта*/}
                                <td>{p.materialName}</td>
                                <td>{p.coatings.map((c) => c.name).join(", ")}</td>
                                <td>
                                    {p.sizeUser !== -1 ? `${p.sizeUser}мм` : "—"}
                                    {!isForDesigner && p.thicknessUser !== -1 ? ` × ${p.thicknessUser}мм` : ""}
                                </td>
                                <td>
                                    {p.additions && p.additions.length > 0
                                        ? p.additions
                                            .filter(a => a.isForExport)
                                            .map(a => a.name)
                                            .join(", ")
                                        : "—"
                                    }
                                </td>
                                {!isForDesigner ? <td>{p.selfCount || 1} шт.</td> : ''}
                            </tr>
                        ))}
                        {order.customProducts?.map((p, index) => (
                            <tr key={p.key || p.id}>
                                <td>{order.products.length + index + 1}</td>
                                <td>{p.name}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                {!isForDesigner ? <td>{p.count || 1} шт.</td> : ''}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    }, [order]);

    const copyToClipboard = () => {
        if (!order) return;

        let workshopText = ``;

        order.products.forEach((p, index) => {
            workshopText += `${index + 1}. `

            if (p.categoryName !== "Диз. прочее") {
                workshopText += `${p.categoryName}, `;
            }

            if (p.subtypeId == 3) workshopText += `${p.name}, `;
            else if (p.subtypeName != null) workshopText += `${p.subtypeName}, `;
            if (p.materialName != null) workshopText += `${p.materialName}, `;
            if (p.coatings && p.coatings.length > 0) {
                workshopText += `${p.coatings.map((c) => c.name).join(", ")}, `;
            }

            if (p.sizeUser !== -1) {
                workshopText += `${p.sizeUser} мм`;
                if (p.thicknessUser !== -1 && !isForDesigner) {
                    workshopText += ` х ${p.thicknessUser} мм`;
                }
                workshopText += `, `;
            }

            if (p.additions && p.additions.length > 0) {
                workshopText += `${p.additions && p.additions.length > 0
                    ? p.additions
                        .filter(a => a.isForExport)
                        .map(a => a.name)
                        .join(", ")
                    : "—"
                    } `;
            }


            if (!isForDesigner) workshopText += `${p.selfCount || 1} шт.`;

            workshopText += `\n`;
        });

        order.customProducts?.forEach((p, index) => {
            workshopText += `${order.products.length + index + 1}. ${p.name}`;
            if (!isForDesigner) workshopText += `, ${p.count || 1} шт.`;
            workshopText += `\n`;
        });

        navigator.clipboard.writeText(workshopText);
    };

    return (
        <Modal
            show={true}
            onHide={onHide}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                {isForDesigner ?
                    <Modal.Title>Выгрузка для дизайнера</Modal.Title>
                    : <Modal.Title>Выгрузка для цеха</Modal.Title>}
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
                <Button variant="primary" onClick={copyToClipboard} className="mb-3">
                    Копировать
                </Button>
                {content}
            </Modal.Body>
        </Modal>
    );
}